import script from "./VueScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./VueScroll.vue?vue&type=script&setup=true&lang=js"

import "./VueScroll.vue?vue&type=style&index=0&id=ac1e1c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac1e1c7a"]])

export default __exports__